import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import './plugins/iview.js'
import i18n from './i18n'
import '@babel/polyfill'
import './plugins/date.js'
//import * as filters from './filters/Filters'

//註冊所有filter
//Object.keys(filters).forEach(filter => Vue.filter(filter, (filters as any)[filter]))

Vue.config.productionTip = false

//初始化eventHub
Vue.prototype.$eventHub = new Vue()

new Vue({
	router,
	i18n,
	render: h => h(App),
}).$mount('#app')
